import { ValueOf } from '@vy/utils';

export const RENEW_CONTRACT_OPTIONS = Object.freeze({
  Auto: 'Auto',
  SameTerms: 'SameTerms',
  NewTerms: 'NewTerms',
});

export type RenewContractOption = ValueOf<typeof RENEW_CONTRACT_OPTIONS>;
